import React from 'react'
import { StyleSheet } from 'react-native'
import MaterialIcon from 'react-native-vector-icons/MaterialIcons'
import MaterialCommunityIcon from 'react-native-vector-icons/MaterialCommunityIcons'
import { IconPack } from '@src/components/Icon/types'

const CustomIcon = ({
  name,
  pack,
  color,
  size,
  style,
}: {
  name: string
  pack: string
  color?: string
  size?: number
  style?: any
}) => {
  const { width, tintColor, ...iconStyle } = StyleSheet.flatten(style || {})
  const iconColor = color || tintColor
  const iconSize = size || width
  switch (pack) {
    case IconPack.Material:
      return <MaterialIcon name={name} color={iconColor} size={iconSize} style={iconStyle} />
    case IconPack.MaterialCommunity:
      return (
        <MaterialCommunityIcon name={name} color={iconColor} size={iconSize} style={iconStyle} />
      )
    default:
      return null
  }
}

const IconProvider = (name: string, pack: string) => ({
  toReactElement: (props: any) => CustomIcon({ name, pack, ...props }),
})

const createIconsMap = (pack: string) =>
  new Proxy(
    {},
    {
      get: (_, name: string) => IconProvider(name, pack),
    },
  )

export const MaterialIconsPack = {
  name: IconPack.Material,
  icons: createIconsMap(IconPack.Material),
}

export const MaterialCommunityIconsPack = {
  name: IconPack.MaterialCommunity,
  icons: createIconsMap(IconPack.MaterialCommunity),
}
